import { VInput, cn } from '@vrzl/ui';
import { Search } from 'lucide-react';

const DEFAULT_PLACEHOLDER = 'Zoek op criterium';

type CriteriaSearchProps = {
  value: string;
  onChange: (value: string) => void;
  /** Default: 'Zoek op criterium'. */
  placeholder?: string;
  /** Breedte en marges bepaalt de callsite; het veld vult zijn wrapper. */
  className?: string;
};

/**
 * Gecontroleerd zoekveld voor criterialijsten. Bevat geen state en geen
 * filterlogica — die zitten in `useCriteriaSearch` respectievelijk
 * `filterByQuery`.
 */
export function CriteriaSearch({
  value,
  onChange,
  placeholder = DEFAULT_PLACEHOLDER,
  className,
}: CriteriaSearchProps) {
  return (
    <div className={cn('relative', className)}>
      <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
      <VInput
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        className="w-full pl-9"
      />
    </div>
  );
}

export type { CriteriaSearchProps };
